import { Flex } from '@grupoboticario/flora-react';
import {
  PixOutlineIcon,
  BarcodeFillIcon,
  CardIcon,
  DollarSignCircleIcon,
} from '@grupoboticario/flora-react-icons';
import { useParams } from 'react-router-dom';

import { Divider, Skeleton, Card, ResponsiveFloraTypography } from 'components';
import { PaymentDetail, Renegotiation } from 'components/Drawers';
import { DRAWERS, ORDERS_STATUS, PAYMENT_METHODS } from 'config/environments/shared';
import { useOrderDetail, useDrawer } from 'hooks';

import { PaymentCard, Refund } from './components';
import Styles from './Payment.styles';

export const Payment = () => {
  const { id = '0' } = useParams<{ id: string }>();
  const { data: order, isLoading } = useOrderDetail(id);
  const { isOpen: paymentDetailIsOpen } = useDrawer(DRAWERS.PAYMENT_DETAIL);
  const { isOpen: renegotiationIsOpen } = useDrawer(DRAWERS.RENEGOTIATION);

  const getPaymentIcon = (planType: string) => {
    switch (planType) {
      case PAYMENT_METHODS.PIX:
        return <PixOutlineIcon />;
      case PAYMENT_METHODS.BANKBILLING:
        return <BarcodeFillIcon />;
      case PAYMENT_METHODS.CREDIT_CARD:
        return <CardIcon />;
      default:
        return <DollarSignCircleIcon />;
    }
  };

  if (isLoading) {
    return (
      <Styles.Wrapper data-testid='skeleton-payment'>
        <Card>
          <Flex direction='column' gap='$4'>
            <Skeleton height='$5' />
            <Divider variant='Line' />
            <Skeleton height='$5' />
            <Skeleton height='$15' />
          </Flex>
        </Card>
      </Styles.Wrapper>
    );
  }

  return (
    <Styles.Wrapper data-testid='payment'>
      <Card>
        <Flex direction='column' gap='$4'>
          <ResponsiveFloraTypography as='h2' fontSize='subtitle' fontWeight='bold'>
            Pagamento
          </ResponsiveFloraTypography>
          <Divider variant='Line' />

          {order?.payment[0].titles &&
            order?.payment.map((payment, paymentIndex) => (
              <>
                <Flex gap='$2' align='center' key={`${paymentIndex}-${payment.label}`}>
                  {getPaymentIcon(payment.icon)}
                  <ResponsiveFloraTypography>{payment.label}</ResponsiveFloraTypography>
                </Flex>
                {order?.status !== ORDERS_STATUS.CANCELED && (
                  <>
                    {payment.titles
                      .filter(
                        (title) =>
                          title.planType === PAYMENT_METHODS.BANKBILLING ||
                          title.planType === PAYMENT_METHODS.PIX
                      )
                      .map((title, titleIndex) => (
                        <Flex
                          data-testid='list-payments'
                          key={`${titleIndex}-${title.planType}`}
                          direction='column'
                          gap='$2'
                        >
                          <PaymentCard payment={title} />
                        </Flex>
                      ))}
                  </>
                )}
              </>
            ))}

          <Refund
            message={order?.payment[0].refund?.message ?? ''}
            shouldShow={order?.payment[0].refund?.shouldShow ?? false}
          />
        </Flex>
      </Card>
      {paymentDetailIsOpen && <PaymentDetail />}
      {renegotiationIsOpen && <Renegotiation />}
    </Styles.Wrapper>
  );
};
